import { Aurelia, PLATFORM } from 'aurelia-framework';
export function configure(aurelia: any) {
	aurelia
		//.globalResources(PLATFORM.moduleName('./application-claim-types'))
		//.globalResources(PLATFORM.moduleName('./application-error'))
		//.globalResources(PLATFORM.moduleName('./application-state'))
		.globalResources(PLATFORM.moduleName('./application-user'))
		.globalResources(PLATFORM.moduleName('./claim'))
		.globalResources(PLATFORM.moduleName('./device'))
		.globalResources(PLATFORM.moduleName("./digital-output-toggle-request-view-model"))
		.globalResources(PLATFORM.moduleName("./location"))
		.globalResources(PLATFORM.moduleName('./notification-recipient'))
		.globalResources(PLATFORM.moduleName("./structure"))
		.globalResources(PLATFORM.moduleName('./user-preference'))
		.globalResources(PLATFORM.moduleName("./zone"));
}